module.exports = __webpack_public_path__ + "img/icon-bendungan.abcc4696.png";